import React from 'react';
import { Route, Switch } from 'react-router-dom';
// import FilterableTable from './containers/FilterableTable';
// import About from './components/About';
// import Settings from './containers/Settings';
import Project from './containers/Project';
// import Projects from './containers/Projects';
// import NewProjectDialog from './containers/NewProjectDialog';

export default (
	<Switch>
		<Route exact path="/" component={Project} />
	</Switch>
);
